<template>
  <div class="page-container stock-kits-page">
    <portal to="page-name">Kits de produtos</portal>
    <div class="card card-page">
      <div class="card-header">
        <h1 class="card-title">Kits de produtos</h1>
      </div>
      <div class="card-body">
        <div class="columns">
          <div class="column form-group">
            <div class="input-group">
              <input type="text" id="filter-search" name="filter-search" class="form-input"
                     v-model="filter.search" maxlength="100"
                     placeholder="Informe o nome para pesquisar">
              <button class="btn btn-neutral btn-action input-group-btn btn-icon" tabindex="-1">
                <fa-icon :icon="['fal', 'search']"/>
              </button>
            </div>
          </div>
          <div class="column col-auto">
            <button class="btn btn-primary btn-icon btn-icon-left"
                    @click="create">
              <fa-icon :icon="['fal', 'plus']"/> Novo kit
            </button>
          </div>
        </div>
        <div class="loading loading-lg mt-2" v-if="loading"></div>
        <template v-else>
          <div class="empty mt-2" v-if="data.items.length === 0">
            <div class="empty-icon">
              <fa-icon :icon="['fal', 'info-circle']" size="3x"/>
            </div>
            <p class="empty-title h5">Kits</p>
            <p class="empty-subtitle">
              Nenhum kit encontrado. Verifique os filtros para realizar novas buscas
            </p>
          </div>
          <table class="table table-striped table-hover" v-else>
            <thead>
            <tr>
              <th>#</th>
              <th>Código</th>
              <th>Status</th>
              <th>Nome</th>
              <th class="text-center">Validade</th>
              <th class="text-center">Quantidade</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, i) in data.items" :key="i">
              <td>{{ i + 1 }}</td>
              <td style="width:150px">
                <router-link :to="editLink(item)">
                  {{ item.code }}
                </router-link>
              </td>
              <td>
                <span :class="getStyle(item.status)">
                  {{ status.getName(item.status) }}
                </span>
              </td>
              <td>{{ item.name }}</td>
              <td class="text-center">{{ item.validity | date('DD/MM/YYYY') }}</td>
              <td class="text-center">
                {{ item.quantity.current | number }} de {{ item.quantity.total | number }}
              </td>
              <td class="text-right">
<!--                <button class="btn btn-sm btn-action btn-icon btn-gray tooltip mr-1"-->
<!--                        :class="{loading: duplicating}"-->
<!--                        :disabled="duplicating"-->
<!--                        @click="duplicate(item.id)" data-tooltip="Duplicar">-->
<!--                  <fa-icon :icon="['fal', 'copy']"></fa-icon>-->
<!--                </button>-->
                <button class="btn btn-sm btn-action btn-icon btn-gray mr-1"
                        @click="edit(item)">
                  <fa-icon :icon="['fal', 'pencil']" v-if="item.status === 'open'" />
                  <fa-icon :icon="['fal', 'search']" v-else />
                </button>
                <button class="btn btn-sm btn-error btn-icon btn-action"
                        :class="{loading: deleting}"
                        @click="remove(item.id, i)"
                        :disabled="deleting"
                        v-if="item.status === 'open'">
                  <fa-icon :icon="['fal', 'times']"/>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
      <div class="card-footer" v-if="data.items.length > 0">
        <span>Total de registros:
          <span class="ml-2 text-primary text-bold">{{ data.total }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import * as status from 'src/data/stock-kit-statuses';
import { DELETE_KIT, DUPLICATE_KIT } from '@/data/actions/modules/stock';

export default {
  data() {
    return {
      debounceTimeout: null,
      loading: false,
      deleting: false,
      duplicating: false,
      status,
      filter: {
        search: '',
      },
      data: {
        items: [],
        total: 0,
        limit: 30,
        offset: 0,
      },
    };
  },
  watch: {
    filter: {
      handler() {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(this.search, 600);
      },
      deep: true,
    },
  },
  computed: {
    canAccessRemoveKit() {
      if (DELETE_KIT) {
        return this.$can(DELETE_KIT);
      }
      return true;
    },
    canAccessDuplicateKit() {
      if (DUPLICATE_KIT) {
        return this.$can(DUPLICATE_KIT);
      }
      return true;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    search() {
      this.data.offset = 0;
      this.load();
    },
    load() {
      this.loading = true;

      const params = {
        limit: this.data.limit,
        offset: this.data.offset,
      };

      if (this.filter.search.trim().length > 0) {
        params.search = this.filter.search;
      }

      this.$http.get('/stock-kits', { params })
        .then(({ data }) => {
          this.data = data;
        })
        .catch(() => {})
        .then(() => {
          this.loading = false;
        });
    },
    create() {
      this.$router.push('/stock/kits/create');
    },
    edit(item) {
      this.$router.push(`/stock/kits/${item.id}/edit`);
    },
    duplicate(id) {
      if (!this.canAccessDuplicateKit) {
        this.$toast.show('Acesso não autorizado!', { type: 'error' });
        return;
      }
      this.$dialog.show('', {
        html:
          '<div class="text-center">'
          + '<h5 class="text-center">Atenção!</h5>'
          + '<div>Deseja realmente duplicar este kit?</div>'
          + '</div>',
        buttons: [
          {
            label: 'Não',
            classes: '',
          }, {
            label: 'Sim',
            classes: 'btn-primary btn-error ml-2',
            click: (close) => {
              this.duplicating = true;
              this.$http
                .post(`/stock-kits/${id}/duplicate`)
                .then(() => {
                  this.load();
                })
                .catch(() => {
                  this.$toast('Não foi possível duplicar', { type: 'error' });
                })
                .finally(() => {
                  this.duplicating = false;
                });
              close();
            },
          },
        ],
      });
    },
    editLink(item) {
      return `/stock/kits/${item.id}/edit`;
    },
    remove(id, i) {
      if (!this.canAccessRemoveKit) {
        this.$toast.show('Acesso não autorizado!', { type: 'error' });
        return;
      }
      this.$dialog.show('', {
        html:
          '<div class="text-center">'
          + '<h5 class="text-center">Atenção!</h5>'
          + '<div>Deseja realmente excluir este registro?</div>'
          + '</div>',
        buttons: [
          {
            label: 'Não',
            classes: '',
          }, {
            label: 'Sim',
            classes: 'btn-primary btn-error ml-2',
            click: (close) => {
              this.deleting = true;
              this.$http
                .delete(`/stock-kits/${id}`)
                .then(() => {
                  this.data.items.splice(i, 1);
                })
                .catch(() => {
                })
                .then(() => {
                  this.deleting = false;
                  close();
                });
            },
          },
        ],
      });
    },
    getStyle(kitStatus) {
      if (kitStatus === 'open') {
        return 'text-warning text-bold';
      } if (kitStatus === 'available') {
        return 'text-info text-bold';
      }
      return '';
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";
.stock-kits {
}
</style>
